import React from 'react';
import { useI18n } from 'react-simple-i18n';
import { Link } from 'react-router-dom';
import appstate, { getLocaledString } from '../appstate';
import modulepic1 from '../assets/img/modulepics/1-min.jpg';
import modulepic2 from '../assets/img/modulepics/99min.jpg';
import modulepic3 from '../assets/img/modulepics/33.jpg';
import modulepic4 from '../assets/img/modulepics/2-min.jpg';
import modulepic5 from '../assets/img/modulepics/5-min.jpg';
import modulepic6 from '../assets/img/modulepics/3-min.jpg';
import modulepic7 from '../assets/img/modulepics/7-min.jpg';
import modulepic8 from '../assets/img/modulepics/8-min.jpg';
import hat from '../assets/img/hat.png';

export default function ModulesView() {
	const { t } = useI18n();

	const [activeSection, setActiveSection] = React.useState(-1);
	const [headHeightsSum, setHeadHeightsSum] = React.useState<number>(0);

	const hoveredClasses = '!w-3/5';
	const adjacentClasses = '!w-2/5';

	const chevronRightIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke="currentColor"
			className="w-6 h-6"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8.25 4.5l7.5 7.5-7.5 7.5"
			/>
		</svg>
	);

	const mouseOuted = () => {
		setActiveSection(-1);

		const modules = document.querySelectorAll('.module');

		modules.forEach((m) => {
			hoveredClasses.split(' ').forEach((c) => {
				return m.classList.remove(c);
			});
			adjacentClasses.split(' ').forEach((c) => {
				return m.classList.remove(c);
			});
		});
	};

	// On mounted
	React.useEffect(() => {
		// if mouse is over body, set activeSection to -1
		document.body.addEventListener('mouseover', mouseOuted);

		const head1 = document.getElementById('head1');
		const head1Height = head1 ? head1.clientHeight : 0;

		const head2 = document.getElementById('head2');
		const head2Height = head1 ? head1.clientHeight : 0;

		setHeadHeightsSum(head1Height + head2Height);
	}, []);

	const modules = [
		{
			title: t('pageTitles./module/1'),
		},
		{
			title: t('pageTitles./module/2'),
		},
		{
			title: t('pageTitles./module/3'),
		},
		{
			title: t('pageTitles./module/4'),
		},
		{
			title: t('pageTitles./module/5'),
		},
		{
			title: t('pageTitles./module/6'),
		},
		{
			title: t('pageTitles./module/7'),
		},
		{
			title: t('pageTitles./module/8'),
		},
	];

	const getBgForIndex = (index: number) => {
		if (index === 0) {
			return modulepic1;
		}
		if (index === 1) {
			return modulepic2;
		}
		if (index === 2) {
			return modulepic3;
		}
		if (index === 3) {
			return modulepic4;
		}
		if (index === 4) {
			return modulepic5;
		}
		if (index === 5) {
			return modulepic6;
		}
		if (index === 6) {
			return modulepic7;
		}
		if (index === 7) {
			return modulepic8;
		}

		return modulepic1;
	};

	const pdfSvgIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke="currentColor"
			className="w-6 h-6 pt-1"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
			/>
		</svg>
	);

	return (
		<div
			onMouseOver={(e) => {
				e.stopPropagation();
			}}
		>
			<div
				className={
					'flex text-white flex-col md:flex-row flex-wrap mb-12 relative'
				}
			>
				<img
					src={hat}
					alt={''}
					className={
						'hidden md:flex absolute top-0 transform -translate-y-full z-1000 right-4 w-12'
					}
				/>
				{modules.map((module, index) => {
					return (
						<Link
							to={`${appstate
								.routes()
								.module.path.replace(
									':id',
									(index + 1).toString(),
								)}`}
							key={index}
							id={'module' + index}
							onMouseEnter={(e) => {
								mouseOuted();
								e.stopPropagation();
								e.preventDefault();

								setActiveSection(index);

								const target = (e.target as HTMLElement)!;

								hoveredClasses.split(' ').forEach((c) => {
									return target.classList.add(c);
								});

								const adjacent = (
									index % 2 === 0
										? target.nextElementSibling
										: target.previousElementSibling
								) as HTMLElement;

								adjacentClasses.split(' ').forEach((c) => {
									return adjacent!.classList.add(c);
								});
							}}
							style={{
								background: `url(${getBgForIndex(index)})`,
								backgroundPosition: '0 150px',
								backgroundSize: 'cover',
							}}
							className={
								'group module transition-all w-full md:w-1/2 border group overflow-hidden md:h-30'
							}
						>
							<div
								className={
									'relative pointer-events-none w-full transition group-hover:duration-500 duration-150 h-full flex justify-start items-end text-lg font-bold p-4 bg-primary-500/80 group-hover:bg-primary-500/50 backdrop-blur-sm'
								}
							>
								<div>
									<div
										className={
											'transform transition group-hover:-translate-x-1 text-shadow'
										}
									>
										{module.title}
									</div>
									<div
										className={
											'opacity-0 group-hover:opacity-100 transition transform absolute delay-0 right-0 group-hover:-translate-x-9 duration-300'
										}
										style={{
											bottom:
												index % 2 === 0
													? '17px'
													: '19px',
										}}
									>
										{chevronRightIcon}
									</div>
								</div>
							</div>
						</Link>
					);
				})}
			</div>
		</div>
	);
}
